import {
  ADD_NEW_C_TARGETING_FAILED,
  ADD_NEW_C_TARGETING_REQUEST,
  ADD_NEW_C_TARGETING_SUCCESS,
  GET_C_TARGETING_LIST_REQUEST,
  GET_C_TARGETING_LIST_FAILED,
  GET_C_TARGETING_LIST_SUCCESS,
  GET_C_TARGETING_SEGMENTS_REQUEST,
  GET_C_TARGETING_SEGMENTS_FAILED,
  GET_C_TARGETING_SEGMENTS_SUCCESS
} from "../Actions/CtargetingActions";

const initialState = {
  loading: false,
  success: false,
  segmentData: [],
  list_fetching: false,
  historyData: [],
};

export const CTargetingReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_C_TARGETING_SEGMENTS_REQUEST:
      return {
        ...state,
        loading: true
      };
    case GET_C_TARGETING_SEGMENTS_SUCCESS:
      return {
        ...state,
        segmentData:action.payload,
        loading: false
      };
    case GET_C_TARGETING_SEGMENTS_FAILED:
      return {
        ...state,
        segmentData:[],
        loading: false
      };

    case ADD_NEW_C_TARGETING_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case ADD_NEW_C_TARGETING_SUCCESS:
      return {
        ...state,
        loading: false,
        success: true,
      };
    case ADD_NEW_C_TARGETING_FAILED:
      return {
        ...state,
        loading: false,
        success: false,
      };
    case GET_C_TARGETING_LIST_REQUEST:
      return {
        ...state,
        list_fetching: true,
      };
    case GET_C_TARGETING_LIST_SUCCESS:
      return {
        ...state,
        list_fetching: false,
        success: true,
        historyData: action.payload
      };
    case GET_C_TARGETING_LIST_FAILED:
      return {
        ...state,
        list_fetching: false,
        success: false,
      };
    default:
      return state;
  }
};
